<div class="arrow-cell-renderer-wrapper" [ngClass]="cellClass"> 
  <nv-icon *ngIf="icon" [name]="icon"></nv-icon>
  <div class="icon-space-filler" *ngIf="!icon && displayValue !== '—'" ></div>
  <div>{{displayValue}}</div> 
</div>
